import { Controller } from '@hotwired/stimulus'
import { $getSelection, $createTextNode } from 'lexical'
import { CustomActionTextAttachmentNode } from '@37signals/lexxy'
import { escapeHtml, questionLabels } from '../helpers'

const ANSWER_CONTENT_TYPE = 'application/vnd.cando.answer'

export default class extends Controller {
  static targets = ['editor', 'field', 'chips']

  connect () {
    this.onChange = () => this.sync()
    this.editorTarget.addEventListener('lexxy:change', this.onChange)
    this.refreshChips()
  }

  disconnect () {
    this.editorTarget.removeEventListener('lexxy:change', this.onChange)
  }

  sync () {
    const html = this.editorTarget.value || ''
    if (html === this.fieldTarget.value) return
    this.fieldTarget.value = html
    this.fieldTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }

  insert (event) {
    event.preventDefault()
    const label = event.currentTarget.dataset.label
    const editor = this.editorTarget.editor
    if (!label || !editor) return

    editor.focus()
    editor.update(() => {
      const selection = $getSelection()
      if (!selection) return
      const chip = new CustomActionTextAttachmentNode({
        contentType: ANSWER_CONTENT_TYPE,
        innerHtml: escapeHtml(label),
        plainText: label
      })
      selection.insertNodes([chip, $createTextNode(' ')])
    })
  }

  refreshChips () {
    if (!this.hasChipsTarget) return
    const labels = questionLabels()

    if (!labels.length) {
      this.chipsTarget.innerHTML = '<span class="text-xs text-gray-400 italic">Add questions first — then drop their answers into the body.</span>'
      return
    }
    this.chipsTarget.innerHTML = labels.map((label) => {
      const safe = escapeHtml(label)
      return `<button type="button" data-action="lexxy-field#insert" data-label="${safe}" class="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full border bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100 transition">+ ${safe}</button>`
    }).join('')
  }
}
